import React from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { intl } from "LocaleWrapper";
import { FormGroup, Table } from "@cofano/cck";
import ProductSelect from "view/products/components/select/ProductSelect";
import { Language } from "imports/Utils";
import { RelationSchemaInput, RelationSchemaOutput } from "view/relations/utils/relation.schema";

const RelationProductsForm = () => {

	const { control } = useFormContext<RelationSchemaInput, unknown, RelationSchemaOutput>();

	const products = useWatch({ control, name: "products" });

	return (
		<React.Fragment>
			<FormGroup label={Language("PRODUCTS")} labelPlacement="left-center" overflow="hidden">
				<Controller
					name="products"
					control={control}
					render={({ field }) => <ProductSelect {...field} multiple />} />
			</FormGroup>

			<Table
				id="relationProductsTable"
				content={products ?? []}
				columns={[ {
					id: "name",
					title: intl.formatMessage({ id: "PRODUCTS_NAME" }),
				}, {
					id: "code",
					title: intl.formatMessage({ id: "PRODUCTS_CODE" }),
				}, {
					id: "description",
					title: intl.formatMessage({ id: "PRODUCTS_DESCRIPTION" }),
				} ]}
				disableFooter />
		</React.Fragment>
	);
};

export default RelationProductsForm;
